import { ArrowLeftOutlined } from '@ant-design/icons';
import { ContentFilters } from 'components';
import { NotificationDetailsFilterFormValues} from 'features/notification/components/type';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CompanyType } from 'types';

import { NotificationDetailsFilterForm } from 'features/notification/components/top-bar/notification-detail-filter-form';
// /notification-detail-filter-form
type VendingTopBarProps = {
  getInitialFilterValues: NotificationDetailsFilterFormValues;
  handleFilter: (values: NotificationDetailsFilterFormValues) => void;
};
export const NotificationDetailTopBarLists = ({
  getInitialFilterValues,
  handleFilter
  

}: VendingTopBarProps) => {
  useState<CompanyType>();
  const navigate = useNavigate();
  const formId = 'notification-detail-filters-form';
 // const [showAddItemModal, setShowAddItemModal] = useState<boolean>(false);
  // const handleOpenModal = () => {
  //   setShowAddItemModal(true)
  //   document.body.style.overflow = 'hidden';
  // }

  // const handleCloseModal = () => {
  //   setShowAddItemModal(false)
  //   document.body.style.overflow = 'visible';
  // }

  return (
    <>
      {/* <div className={`cstmrightmdl ${showAddItemModal && "show"}`}>
        <AddNotificationModal onClose={handleCloseModal} refetch={refetch} showAddItemModal={showAddItemModal} />
      </div> */}

       {/* <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <ArrowLeftOutlined
            style={{ fontSize: 20, cursor: "pointer" }}
            onClick={() => navigate("/notification/lists")}
          />
          <span>Notification List - Details</span>
        </div> */}
        
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom:'10px' }}>
          <ArrowLeftOutlined
            style={{ fontSize: 20, cursor: "pointer" }}
            onClick={() => navigate("/notification/lists")}
          />
             <h2 style={{fontSize:'16px' , fontWeight:500}}>Notification List - Details</h2>
          

         </div>
         
        
        {/* <ContentTopBar
          title={'Notification List - Details'}
        />  */}


      <ContentFilters formId={formId}>
        <NotificationDetailsFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
